import initialState from './initialState';
import {
  FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL,
  FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_FAILURE,
} from './types';

const adminTaxEntrySettings = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL:
      return {
        ...state,
        isFetchingInitialDataForAddModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_SUCCESS:
      return {
        ...state,
        isFetchingInitialDataForAddModal: false,
        typeValues: payload.taxEntryTypeValues,
        activityValues: payload.taxEntryActivityValues,
        slViewValues: payload.taxEntryViewValues,
      };
    case FETCH_INITIAL_DATA_FOR_ADMIN_TAX_ENTRY_MODAL_FAILURE:
      return {
        ...state,
        isFetchingInitialDataForAddModal: false,
      };
    default:
      return state;
  }
};

export default adminTaxEntrySettings;
